import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { EmitirNFCe, AvisoDocumentoBloqueado } from "@/fiscal";
import { api, errMsg } from "@/lib/api";

export function NfceDialog({ saleId, onDone }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!saleId) {
      return;
    }
    setData(null);
    setError("");
    api.get(`/fiscal-bridge/sales/${saleId}/nfce`).then((r) => setData(r.data)).catch((e) => setError(errMsg(e)));
  }, [saleId]);
  const missing = data?.faltando_ncm || [];
  return (
    <Dialog open={!!saleId} onOpenChange={(o) => !o && onDone(null)}>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="nfce-modal">
        <DialogHeader>
          <DialogTitle>NFC-e da venda</DialogTitle>
          <DialogDescription>Informe o CPF/CNPJ se o cliente pedir e emita o cupom fiscal.</DialogDescription>
        </DialogHeader>
        {!data && !error && <p className="text-sm text-muted-foreground" data-testid="nfce-loading">Carregando…</p>}
        {error && <p className="rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive" data-testid="nfce-error">{error}</p>}
        {missing.length > 0 && (
          <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm" data-testid="nfce-missing-ncm">
            <p className="font-medium">Produtos sem NCM não podem sair na NFC-e:</p>
            <p className="mt-1">{missing.join(", ")}</p>
            <p className="mt-1 text-xs text-muted-foreground">Cadastre o NCM em Produtos → editar o produto (campo NCM, logo abaixo do nome) e emita a nota depois em Fiscal → Notas.</p>
          </div>
        )}
        <AvisoDocumentoBloqueado tipo="nfce" />
        {data && !missing.length && <div className="text-gray-900" data-testid="nfce-emitter"><EmitirNFCe venda={data.venda} onConcluido={onDone} abrirDanfe={false} /></div>}
        {(error || missing.length > 0) && <Button variant="outline" onClick={() => onDone(null)} data-testid="nfce-skip-btn">Seguir sem nota</Button>}
      </DialogContent>
    </Dialog>
  );
}
